export enum BonCommandeStatus {
  BROUILLON = 'brouillon',
  ENVOYEE = 'envoyee',
  RECUE = 'recue',
  ANNULEE = 'annulee',
}

export const BC_STATUS_LABELS: Record<string, string> = {
  brouillon: 'Brouillon',
  envoyee: 'Envoyée',
  recue: 'Reçue',
  annulee: 'Annulée',
};

export interface BonCommandeItem {
  id: number;
  bon_commande_id: number;
  article_id?: number | null;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
  created_at?: string;
  // Enriched
  article_reference?: string | null;
  unit?: string | null;
}

export interface BonCommandeItemCreate {
  article_id?: number | null;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface BonCommande {
  id: number;
  reference: string;
  date: string;
  demande_achat_id: number;
  da_reference?: string | null;
  projet_code?: string | null;
  projet_nom?: string | null;
  supplier_devis_ref?: string | null;
  supplier_id: number;
  supplier_name?: string | null;
  supplier_code?: string | null;
  supplier_ice?: string | null;
  supplier_address?: string | null;
  condition_paiement_id?: number | null;
  condition_nom?: string | null;
  condition_description?: string | null;
  mode_paiement_id?: number | null;
  mode_nom?: string | null;
  user_id: number;
  user_name?: string | null;
  status: BonCommandeStatus | string;
  remarque?: string | null;
  montant_total: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  items: BonCommandeItem[];
  total_items: number;
}

export interface BonCommandeCreate {
  date: string;
  demande_achat_id: number;
  supplier_id: number;
  condition_paiement_id?: number | null;
  mode_paiement_id?: number | null;
  remarque?: string | null;
  supplier_devis_ref?: string | null;
  items: BonCommandeItemCreate[];
}

export interface BonCommandeUpdate extends BonCommandeCreate {
  status?: string;
}

export interface BonCommandeStatusUpdate {
  status: BonCommandeStatus | string;
}

export interface BonCommandeListResponse {
  total: number;
  items: BonCommande[];
}

export interface BonCommandeFilters {
  reference?: string;
  statuses?: string[];
  supplier_ids?: number[];
  user_ids?: number[];
  demande_achat_id?: number;
  start_date?: string;
  end_date?: string;
}
